import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranhistoryService {

  constructor(
    private requestService: RequestService
  ) { }
  GetTranHistory(CompanyID:string, UserID:string){
    var param = {
      "CompanyID": CompanyID,
      "UserID": UserID
    };
    return this.requestService.Post<string>(environment.baseUrl + '/SaleBase/GetTranHistory',param);
  }

  ShowMoreHistory(CompanyID:string, UserID:string){
    var param = {
      "CompanyID": CompanyID,
      "UserID": UserID
    };
    return this.requestService.Post<string>(environment.baseUrl + '/SaleBase/ShowMoreHistory',param);
  }
}
